











































































import {
    Component, Vue, Prop, Watch,
} from 'vue-property-decorator';
import { CSVFile } from '@/store/modules/csv';

@Component
export default class ZebraListItem extends Vue {
    @Prop() readonly value!: CSVFile;
    @Prop({ default: -1 }) readonly activeIndex!: number;
    @Prop({ default: -1 }) readonly renameActiveIndex!: number;
    @Prop({ default: [] }) readonly menuItems!: string[];
    @Prop({ default: -1 }) readonly index!: number;

    // menu properties
    public x = 0;
    public y = 0;
    public showMenu = false;

    public renameModel = '';

    public initShowMenu(xAxis: number, yAxis: number) {
        this.showMenu = false;
        this.x = xAxis;
        this.y = yAxis;
        this.$nextTick(() => {
            this.showMenu = true;
        });
    }

    public onHammerPress(e: any) {
        if (this.index !== this.renameActiveIndex) {
            this.$emit('update:activeIndex', this.index);
            this.initShowMenu(e.center.x - 5, e.center.y - 5);
        }
    }

    public onRightClick(e: any) {
        if (this.index !== this.renameActiveIndex) {
            this.$emit('update:activeIndex', this.index);
            this.initShowMenu(e.clientX, e.clientY);
        }
    }

    public onMenuItemClick(index: number) {
        this.$emit(`click${this.menuItems[index]}`);
    }

    public updaterenameActiveIndex() {
        this.$emit('update:renameActiveIndex', this.index);
    }

    public onRenameFinish(newName: string) {
        this.$emit('rename', newName);
        this.$emit('update:renameActiveIndex', -1);
    }

    public onRenameFinish2() {
        this.$emit('update:renameActiveIndex', -1);
    }

    @Watch('renameActiveIndex')
    private onRenameActiveListChange(val: number) {
        if (val !== -1) {
            this.renameModel = this.value.name;
        }
    }
}
